
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M17.25 9.25h9v15h-9zM3.75 12.25h10.5v12H3.75zM5.25 12.25V4A.75.75 0 016 3.25h6a.75.75 0 01.75.75v8.25M8.25 3.25v-1.5M8.25 9.25h1.5M8.25 6.25h1.5M6.75 15.25h4.5M6.75 18.25h4.5M6.75 21.25h4.5M20.25 15.25h3M20.25 12.25h3M20.25 18.25h3M20.25 21.25h3"}})])])
          )
        }
      }
    